import Swiper from 'swiper';

const testimonialsSection = {
    init: function () {
        const sections = document.querySelectorAll('[data-testimonials-section-js]');

        if (!sections.length) return;

        sections.forEach((section) => {
            this.initSlider(section);
        })
    },

    initSlider: function (section) {
        if (!section) return;

        let el = section.querySelector('.swiper');
        let paginationEl = section.querySelector('.swiper-pagination');

        new Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 24,
            grabCursor: true,
            pagination: {
                el: paginationEl,
                clickable: true,
            },
        });
    },
}

export default testimonialsSection;